<script>
  import { conf, lang } from './stores.js'
  import { i18n, cdn, uuid, translate, trigger, compressImage, fileExt } from "./h.js"
  import I from './G_I.svelte'
  import I18n from './G_I18n.svelte'

  import { tweened } from 'svelte/motion'
	import { cubicOut } from 'svelte/easing'

 
  $: trigger('valueChanged', {value: value, elt: me}) //this replace change() value and elt are not used in form.svelte

  //There is two possible slots:
  //after 
  //before
  
  //all type

  export let type="text" //empty, select, textarea, text, date, datetime, time, fqdn, url, email, range, tel, number, password, color, countries
  export let empty=false
  if(empty) type="empty"


  export let value=undefined
  export let set=undefined  //default value. Note : for multiple checkbox, switch, if set=[] return value as array rather than object
  export let icon=false
  export let legend="" //automatic legend, only on file for instance ...
  export let help=""
  export let helpBefore=""
  export let noLabel=false //take place of label without text an without icon and *
  export let label=""
  export let nomargin=false //removes margin around the all input block
  export let noblock=false //transform the div input block as a span 
  export let placeholder=""
  export let required=null
  export let readonly=null
  export let disabled=null
  export let pattern=null
  export let noPattern=null // do not use pattern at all (even if pattern is defined)

  export let change=()=>{} // not used by G_Input to listen change, just an helper for parent
  export let customValidity=false //fct, implemented only on text...
  export let customValidityInvalidMsg="" // message to display if customValidity returns false


  //input type?
  export let btnAdd=false
  export let btnDelete=false

  //text
  export let asNumber=false //force a text to be converted to a number ( you can achieve the same by using type=number)
  export let btn=false //add button group action
  
  //text, textarea
  export let uppercase=false //auto-uppercase text input
  export let multilang=false
  export let translator=false //propose translation in text and textarea when multilang
  export let button=false //add button action in text textarea
  export let minlength=null
  export let maxlength=null
  export let rows=null

  //text, textarea, select, email
  export let autocomplete=false
 
  //number, range
  export let min=null
  export let max=null

  //Tag  
  export let canAdd=false
  
  //color
  export let colorText=false
  export let smooth=false
  
  //checkbox, switch, radio
  export let inline=false // place all options in line position
  export let labelLeft=""
  export let labelOnly=false //remove input marker, show label only
  export let lg=false //lg checkbox and switch
  export let option=null // single checkbox, switch, return boolean
  export let inCol="" // put checkbox in col ie : "col-sm-6 col-12"

  //checkbox, switch, radio, select
  export let options=[] //multiple checkbox, switch


  //password
  export let showPassword=false 
  export let proposePassword=false 
  export let showStrength=false

  //range
  export let showValue=false //for range, show value at right of label
  export let unit="" //for range, unit with showValue
  export let step=null
  
  //files
  export let multiple=null
  export let accept=""
  export let maxValues=1
  export let maxSize=10
  export let compress=false
  export let noCdn=false
  export let height='6rem'
  export let compressWidth=null
  export let compressType='jpeg'
  export let compressLevel=0.7
  
  //at mount set value default
  if(value==undefined) value=(set!=undefined)?set:""
  
  //after, if value is re-set to undefined, then replace again value with "" if there is not a default set and the value is undefined
  $: if(value==undefined) value=(set!=undefined)?set:""

  $: if(type=="number" || (type=="text" && asNumber)) {
    value=value+1-1 //force number to be a js number value
  }
  
  //autocomplete=autocomplete?"on":"off"
  let name //only for autocomplete : https://developers.google.com/web/updates/2015/06/checkout-faster-with-autofill
  //if(autocomplete) {autocomplete=type; name=type;} //this is the only case where we use name
  if(autocomplete==false && type=="password") {autocomplete="new-password"}

  let patternFqdn="^(?=.{4,255}$)([a-zA-Z0-9_]([a-zA-Z0-9_-]{0,61}[a-zA-Z0-9_])?\.){1,126}[a-zA-Z0-9][a-zA-Z0-9-]{0,61}[a-zA-Z0-9]$"
  let patternDatetimeLocal="[0-9]{4}-[0-9]{2}-[0-9]{2}T[0-9]{2}:[0-9]{2}"
  let patternDate="[0-9]{4}-[0-9]{2}-[0-9]{2}"
  let patternTime="[0-9]{2}:[0-9]{2}"
  let patternPassword='(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z]).{8,}'
  let patternColor='^#[0-9a-fA-F]{3}([0-9a-fA-F]{3})?$'
  //let patternEmail="^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$"
  let patternEmail="^[a-zA-Z0-9._%+\\-]+@[a-zA-Z0-9.\\-]+\\.[a-zA-Z]{2,}$"
  
  let showPwd //use to toggle show/hide pwd
  
  
  if(type=="fqdn" && !pattern) pattern=patternFqdn
  if(type=="datetime" && !pattern) pattern=patternDatetimeLocal
  if(type=="date" && !pattern) pattern=patternDate
  if(type=="time" && !pattern) pattern=patternTime
  if(type=="password" && pattern===true) pattern=patternPassword
  if(type=="color" && !pattern) pattern=patternColor
  if(type=="email" && !pattern) pattern=patternEmail
  
  if(noPattern) pattern=null
  
  let countries = ["Afghanistan","Albania","Algeria","Andorra","Angola","Anguilla","Antigua and Barbuda","Argentina","Armenia","Aruba","Australia","Austria","Azerbaijan","Bahamas","Bahrain","Bangladesh","Barbados","Belarus","Belgium","Belize","Benin","Bermuda","Bhutan","Bolivia","Bosnia and Herzegovina","Botswana","Brazil","British Virgin Islands","Brunei","Bulgaria","Burkina Faso","Burundi","Cambodia","Cameroon","Canada","Cape Verde","Cayman Islands","Central African Republic","Chad","Chile","China","Colombia","Congo","Cook Islands","Costa Rica","Cote D Ivoire","Croatia","Cuba","Curacao","Cyprus","Czech Republic","Denmark","Djibouti","Dominica","Dominican Republic","Ecuador","Egypt","El Salvador","Equatorial Guinea","Eritrea","Estonia","Ethiopia","Falkland Islands","Faroe Islands","Fiji","Finland","France","French Polynesia","French West Indies","Gabon","Gambia","Georgia","Germany","Ghana","Gibraltar","Greece","Greenland","Grenada","Guam","Guatemala","Guernsey","Guinea","Guinea Bissau","Guyana","Haiti","Honduras","Hong Kong","Hungary","Iceland","India","Indonesia","Iran","Iraq","Ireland","Isle of Man","Israel","Italy","Jamaica","Japan","Jersey","Jordan","Kazakhstan","Kenya","Kiribati","Kosovo","Kuwait","Kyrgyzstan","Laos","Latvia","Lebanon","Lesotho","Liberia","Libya","Liechtenstein","Lithuania","Luxembourg","Macau","Macedonia","Madagascar","Malawi","Malaysia","Maldives","Mali","Malta","Marshall Islands","Mauritania","Mauritius","Mexico","Micronesia","Moldova","Monaco","Mongolia","Montenegro","Montserrat","Morocco","Mozambique","Myanmar","Namibia","Nauro","Nepal","Netherlands","Netherlands Antilles","New Caledonia","New Zealand","Nicaragua","Niger","Nigeria","North Korea","Norway","Oman","Pakistan","Palau","Palestine","Panama","Papua New Guinea","Paraguay","Peru","Philippines","Poland","Portugal","Puerto Rico","Qatar","Reunion","Romania","Russia","Rwanda","Saint Pierre and Miquelon","Samoa","San Marino","Sao Tome and Principe","Saudi Arabia","Senegal","Serbia","Seychelles","Sierra Leone","Singapore","Slovakia","Slovenia","Solomon Islands","Somalia","South Africa","South Korea","South Sudan","Spain","Sri Lanka","St Kitts and Nevis","St Lucia","St Vincent","Sudan","Suriname","Swaziland","Sweden","Switzerland","Syria","Taiwan","Tajikistan","Tanzania","Thailand","Timor L'Este","Togo","Tonga","Trinidad and Tobago","Tunisia","Turkey","Turkmenistan","Turks and Caicos","Tuvalu","Uganda","Ukraine","United Arab Emirates","United Kingdom","United States of America","Uruguay","Uzbekistan","Vanuatu","Vatican City","Venezuela","Vietnam","Virgin Islands (US)","Yemen","Zambia","Zimbabwe"];
  if(type=="countries") {
    type="select"
    options=countries
  }

 
  if(type!="tag" && !placeholder) placeholder=" " //normal to match empty input css, except for tag input

  placeholder=i18n(placeholder,$lang)

  let me, invalid

  let currentLang=$conf.langs[0]
  $: if(multilang && !value) value={}
  if(type=="tag" && !value) value=[]
  let addTag

  //protection if we have decided to change type
  $: if(type=="text" || type=="textarea") {
    if(value && !isObject(value) && multilang) value={[$conf.langs[0]]: value}
    if(value && isObject(value) && !multilang) value=value[$conf.langs[0]]
  }

  $: if(uppercase) value = value.toUpperCase()
  $: if(customValidity) checkCustomValidity(value,me)


  let invalidMessage=""
  const checkCustomValidity= async ()=>{
    let check= await customValidity(value, me)
    if(check===false) {
      invalidMessage=i18n(customValidityInvalidMsg || "g|invalid" ,$lang)
      me.setCustomValidity(invalidMessage)
    } else {
      invalidMessage=""
      me.setCustomValidity("")
    }
    trigger('valueChanged',{value: value, elt: me})
  }
 
  const doTranslate=async ()=>{value[currentLang]= await translate($conf.langs[0], value[$conf.langs[0]], currentLang)}
  const doTranslateAll=async ()=>{
    $conf.langs.forEach(async (langKey,i) => {
      if(i) value[langKey]=await translate($conf.langs[0], value[$conf.langs[0]], langKey)
    })
  }
  
  export let id='' //only used for auto icon

  let cl=$$props.class || ''

  let localId= uuid() //Math.floor(Math.random() *1000000)

  /******date datetime*/
  //datetime-local
  function dateToISOLikeButLocal(date,dateOnly) {
    //if(date!== undefined) date=new Date(date)
    //else return
    if(date) date=new Date(date)
    else return
    let ret
    const offsetMs = date.getTimezoneOffset() * 60 * 1000;
    //console.log('offset', date.getTimezoneOffset())
    const msLocal =  date.getTime() - offsetMs;
    const dateLocal = new Date(msLocal);
    const iso = dateLocal.toISOString();
    if(dateOnly) ret=iso.slice(0, 10); //we remove all time
    else ret = iso.slice(0, 16); //we remove seconds
    return ret;
  }
  
  function dateLocalToISO(date) {
    try{
      if(!date.includes("T")) date=date+"T00:00"
      return new Date(date).toISOString();
    } catch(e){return}
  }

  let valueDT
  if(type=="datetime") {
    valueDT=dateToISOLikeButLocal(value)
  }
  $: if(type=="datetime" && valueDT) {
    value=dateLocalToISO(valueDT)
  }

  let valueD
  if(type=="date") {
    valueD=dateToISOLikeButLocal(value, true)
  }
  $: if(type=="date" && valueD) {
    value=dateLocalToISO(valueD)
  }


  /*******File*******/
  if(!$conf.i18n['input--drag files']) $conf.i18n['input--drag files']={en:'drag file(s) on this box or click to browse', fr:'déposez le(s) fichier(s) ou cliquez dans la boîte'}
  if(!$conf.i18n['input--drag file']) $conf.i18n['input--drag file']={en:'drag file on this box or click to browse', fr:'déposez le fichier ou cliquez dans la boîte'}
  if(!$conf.i18n['input--max files']) $conf.i18n['input--max files']={en:'file(s) Max', fr:'fichier(s) maximum'}
  if(!$conf.i18n['input--max size']) $conf.i18n['input--max size']={en:'size Max', fr:'taille maximum'}
  if(!$conf.i18n['input--file is too big']) $conf.i18n['input--file is too big']={en:'File is too big', fr:'Fichier trop volumineux'}
  if(!$conf.i18n['input--too many files selected']) $conf.i18n['input--too many files selected']={en:'Too many files selected', fr:'Trop de fichiers séléctionnés'}

  let extVideo=["mp4","mov","avi","wmv","mpg","mpeg1","mpeg"]
  let extAudio=["wav","mp3","mpeg4","m4a","ogg"]
  let extImage=["jpeg","jpg","png","tiff","gif","svg","svg","webp"]
 


  let readers=[]
  let dragging
  //$: console.log("@File.svelte", 'files',value)
  //$: console.log("@File.svelte", dragging)

  function descr(file){
    //console.log("@File.svelte", "file",file)
    if(isObject(file)) {
      file.src=file.content?file.content:cdn(file)
      if(file.content) file.type=file.content.split(';')[0].split(':')[1].split('/')[0]
      else {
        let ext=fileExt(file.src) //file.src.split('.').pop()
        if(extVideo.includes(ext)) file.type="video"
        else if(extAudio.includes(ext)) file.type="audio"
        else if(extImage.includes(ext)) file.type="image"
        else file.type=ext
      }
      if(!file.type) file.type="file"
      return file
    }
    else {
      let type
      let src=cdn(file)
      let ext=fileExt(src) //src.split('.').pop()
      if(extVideo.includes(ext)) type="video"
      else if(extAudio.includes(ext)) type="audio"
      else if(extImage.includes(ext)) type="image"
      else type=ext
      if(!type) type="image"
      return {src: src, type: type, name:""} 
    }
  }
  
  function input_handler({ target: { files } }) {
    dragging = false
    addFile(files)
  }

  function drop_handler({ dataTransfer: { files, items } }) {
    dragging = false
    addFile(files)
  }

  async function addFile(files){
    //console.log("@File.svelte", 'files',files)
    if(multiple && maxValues && value.length + files.length > maxValues) {
      alert(i18n('input--Too many files selected'))
      return
    }

    let content
    if(files.length) {
      for (let i = 0; i < (multiple?files.length:1); i += 1) {
        if(maxSize && files[i].size > maxSize*1024*1024){
           alert(i18n("input--File is too big"))
        }
        else if(files[i].type) {
					readers[i] = new FileReader()
					readers[i].addEventListener( "load", async function () {
            if(files[i].type.match('^image/') && compress){
              content=await compressImage(readers[i].result, compressWidth, compressType, compressLevel)
            } else content=readers[i].result

            let addVal={
              content: content,
              cdn:!noCdn, //will be recorded in cdn
              type:files[i].type,
              name:files[i].name,
              src: window.URL.createObjectURL(files[i]) //this is used to permit show of new added. This src will be changed by the cdn version after recorded
            }
            //console.log(addVal)
            if(multiple) {
              if(!Array.isArray(value)) value=[]
              value.push(addVal)
              value=value //needed to have reactivity
            }
            else if(Array.isArray(value)) value[0]=addVal
            else value=addVal
          })
          readers[i].readAsDataURL( files[i] ) //makes a base 64 data : 'data:image/png;base64,iVBORw0KGgoA... or 'data:application/vnd.ms-excel;base64,SUQ....
        }
      }
    }
  }

  const handleClickToBrowse=()=>{me.click()}

  const removeFile=(i)=>{
    if(Array.isArray(value)) {value.splice(i, 1)}
    else value=''
    value=value
  }

  /*******color*******/

  const changeColor=(e)=>{
    value=e.target.value
  }  
  let lastColor, timeoutColor
  const moveColor=(e)=>{
    clearTimeout(timeoutColor)
    timeoutColor=setTimeout(() => {
      if(e.target.value==lastColor) {
        value=e.target.value
        lastColor=false
      }
    }, 200)
    lastColor=e.target.value
    if(change) change()
  }

  /*******range*******/
  let valueRange
  if(type=="range" && smooth) {
    valueRange=value
  }
  $: if(type=="range" && smooth && value) {
    valueRange=value
  }

  const changeRange=(e)=>{
    value=e.target.value
  }  
  let lastRange, timeoutRange
  const moveRange=(e)=>{
    clearTimeout(timeoutRange)
    timeoutRange=setTimeout(() => {
      if(e.target.value==lastRange) {
        value=e.target.value
        lastRange=false
      }
    }, 200)
    lastRange=e.target.value
  }

  /***** password : default strength good password meter *****/
  const progress = tweened(0, {
      duration: 400,
      easing: cubicOut
    })
  let colors=['red','orange','yellow','cyan','green']
  let ok='<i style="color:green;" class="fa-light fa-thumbs-up fa-fw"></i>'
  let ko='<i style="color:red;" class="fa-light fa-thumbs-down fa-fw"></i>'
  let len,special,num,lower,upper,strength
  $: if(type=="password"){
    len=(value.length >= 8)
    special=(value.length && (/[^\w\s]/.test(value)))
    num=(/[0-9]+/.test(value))
    lower=(/[a-z]+/.test(value))
    upper=(/[A-Z]+/.test(value))
    strength=len + special + num + lower + upper
    progress.set(strength / 5)
  }

  /******** all ***********/
  function optionsAsArray(options) {
    let ret=[]
    if(options) options.forEach(option => {
      if(isObject(option) && (option.id || option.value)) {
        if(option.value) option.id=option.value
        ret.push(option)
      } else {
        if(isObject(option)) ret.push({id:Object.values(option)[0], name:option}) //probable i18n object
        else ret.push({id:option, name:option})
      }
    })    
    return ret
  }

  function addOpt() {
    if(!value) value=[]
    options.push({id:addTag, name:addTag})
    options=options
    value.push(addTag)
    value=value
    addTag=''
    if(change) change()
  }

  function toggleOpt(id) {
    if(!value) value=[]
    if(value.includes(id)) value = value.filter(item => item !== id)
    else value.push(id)
    value=value
  }

  function isObject(obj){
    return obj && typeof obj === 'object' && obj.constructor === Object
  }

  export function asArray(arr){
    if(!arr) return []
    if(!Array.isArray(arr) ) arr = [ arr ]
    return arr
  }


  if(icon) icon=icons(icon)

  function icons(search){
    if(!search) return
    if(search===true) search="auto"
    if(search.startsWith('fa-brands')) return `${search} fa-fw`
    if(search.startsWith('fa-solid')) return `${search} fa-fw`
    if(search.startsWith('fa-light')) return `${search} fa-fw`
    if(search.startsWith('fa-thin')) return `${search} fa-fw`
    if(search.startsWith('fa-regular')) return `${search} fa-fw`
    if(search.startsWith('fa-duotone')) return `${search} fa-fw`
    if(search.startsWith('fa-')) return `${$conf.faType} ${search} fa-fw`
    if(search.startsWith('fa ')) return `${search} fa-fw`
    let listIcons = {
      logo: 'fa-image',
      image: 'fa-image',
      camera: 'fa-camera',
      pdf: 'fa-file-pdf',
      video: 'fa-file-video',
      file: 'fa-file',
      lang: 'fa-language',
      id: 'fa-hashtag',
      refresh: 'fa-sync',
      apply: 'fa-arrow-to-bottom',
      app: 'fa-cube',
      add: 'fa-plus',
      save: 'fa-save',
      set: 'fa-save',
      delete: 'fa-trash-alt',
      cancel: 'fa-undo-alt',
      tags: 'fa-tags',
      tag: 'fa-tag',
      option: 'fa-ballot',
      looking:'fa-binoculars',
      search: 'fa-search',
      logon: 'fa-user',
      user: 'fa-user',
      cog: 'fa-cog',
      address: 'fa-map-marker-alt',
      zip: 'fa-map-pin',
      street: 'fa-road',
      zipcode: 'fa-map-pin',
      city: 'fa-city',
      state: 'fa-route-interstate',
      country: 'fa-flag',
      company: 'fa-building',
      name: 'fa-user',
      position: 'fa-id-badge',
      url: 'fa-link',
      lang: 'fa-language',
      google: 'fa-brands fa-google',
      twitter: 'fa-brands fa-x-twitter',
      instagram: 'fa-brands fa-instagram',
      linkedin: 'fa-brands fa-linkedin',
      snapchat: 'fa-brands fa-snapchat',
      tiktok: 'fa-brands fa-tiktok',
      pinterest: 'fa-brands fa-pinterest',
      youtube: 'fa-brands fa-youtube',
      whatsapp: 'fa-brands fa-whatsapp',
      flickr: 'fa-brands fa-flickr',
      facebook: 'fa-brands fa-facebook',
      datetimepicker: 'fa-calendar-alt',
      date: 'fa-calendar-alt',
      month: 'fa-calendar-alt',
      datetime: 'fa-calendar-alt',
      color: 'fa-palette',
      taxid: 'fa-hashtag',
      reference: 'fa-hashtag',
      tel: 'fa-phone',
      phone: 'fa-phone',
      mail: 'fa-envelope',
      email: 'fa-envelope',
      fqdn: 'fa-browser',
      file: 'fa-file',
      password: 'fa-key',
      lock:"fa-icon",
      number: 'fa-list-ol',
      button: 'fa-mouse-pointer',
      plus: 'fa-plus',
      success: 'fa-check-square',
      danger: 'fa-exclamation-triangle',
      warning: 'fa-exclamation-circle',
      info: 'fa-info-square',
      alert: 'fa-exclamation-square',
      zoom: 'fa-search-plus',
      gender: 'fa-venus-mars',
      imagepicker: 'fa-image',
      authorization: 'fa-shield-check',
      bic: 'fa-credit-card-blank',
      iban: 'fa-credit-card-blank',
      text: 'fa-text'
    }
    let [labelL, labelR] = i18n(label, $lang).toLowerCase().split('|')
    let ico=search=="auto"?(listIcons[id] || listIcons[label] || listIcons[labelL] || listIcons[labelR] || listIcons[type] || listIcons[search]):listIcons[search]
     
    if(ico && ico.startsWith("fa-brands")) return `${ico} fa-fw`
    else if(ico) return `${$conf.faType} ${ico} fa-fw`
    else return `${$conf.faType} fa-edit fa-fw`
  }

  </script>

<div on:dragstart|stopPropagation 
  class:mb-3={!nomargin && type!="hidden" && type!="empty"} class:inline={noblock} class="G_Input {cl}">
  <slot name="before"/>

  {#if !noLabel && (label || icon) && !["file","hr","hidden","empty"].includes(type) }
    <label for="input{localId}" class="form-label text-wrap">
      {#if icon}<i class="{icon} me-1"></i>{/if}
      <span class="ucfirst">
        <I18n id={label}/><i class="ms-1 {$conf.faType} fa-asterisk text-danger" class:d-none={!required}></i>
      </span>
    </label>
  {/if}
  {#if noLabel }
    <label for="input{localId}" class="form-label">
      &nbsp;
    </label>
  {/if}
  {#if helpBefore}<div class="xsmall text-muted"><I question-circle/> {@html i18n(helpBefore ,$lang)}</div>{/if}

  {#if multilang && (type=="text" || type=="textarea")}
    {#if $conf.langs.length>1}
      {#each $conf.langs as lang, index}
        <button type="button" class="btn {lang == currentLang?'multiLangSelector':''} btn-light btn-xs mb-1 ms-1" style="text-transform: capitalize;" on:click={()=>{currentLang=lang}}>
          {lang}
          {#if value[lang]}
            <i class="text-success {$conf.faType} fa-check fa-fw"></i>
          {:else}
            <i class:text-danger={!index} class:text-warning={index} class="{$conf.faType} fa-exclamation-triangle fa-fw"></i>
          {/if}
        </button>
      {/each}
    {/if}

    {#if translator && currentLang != $conf.langs[0] }
      <button type="button" class="ms-2 mb-1 btn btn-xs btn-outline-secondary" on:click={doTranslate}>
        <I language/>
      </button>
    {/if}
    {#if translator && currentLang == $conf.langs[0] }
      <button type="button" class="ms-2 mb-1 btn btn-xs btn-outline-secondary" on:click={doTranslateAll}>
        <I globe/>
      </button>
    {/if}
  {/if}

  {#if button}
    <button type="button" class="ms-2 mb-1 btn btn-xs btn-outline-secondary" on:click={button.action}>
      <i class="{$conf.faType} fa-{button.icon}"/>
    </button>
  {/if}

  {#if invalidMessage}
    <span class="text-danger">{invalidMessage}</span>
  {/if}

  
  {#if multilang && (type=="text" || type=="textarea")}
    <div class="input-group">
      {#each $conf.langs as lang, index}
        {#if type=="textarea"} <textarea on:keydown ={change} bind:this={me} class:d-none={currentLang!=lang} required={required && !index} {rows} {readonly} {disabled} {pattern} {minlength} {maxlength} bind:value={value[currentLang]} class="validity form-control" id="input{localId}" {placeholder}></textarea>{/if}
        {#if type=="text"} <input on:keydown ={change} bind:this={me} class:d-none={currentLang!=lang} required={required && !index} {rows} {readonly} {disabled} {pattern} {minlength} {maxlength} bind:value={value[currentLang]} type="text" class="validity form-control" id="input{localId}" {placeholder}>{/if}
      {/each}
      {#if btnDelete}<button on:click={btnDelete} class="btn btn-outline-danger" type="button"><I trash/></button>{/if}
      {#if btnAdd}<button on:click={btnAdd} class="btn btn-outline-success" type="button"><I add/></button>{/if}
    </div>
  {/if}

  {#if !multilang && ["textarea","text","date","datetime","time","fqdn","url","email","tel","number","password"].includes(type) }
    <div class="input-group">

      {#if type=="textarea"} <textarea on:keydown ={change} bind:this={me} {required} {readonly} {disabled} {pattern} {minlength} {maxlength} bind:value class="validity form-control" id="input{localId}" {placeholder} {autocomplete} {name}></textarea>{/if}
      {#if type=="text"} <input on:keydown ={change} bind:this={me} {required} {readonly} {disabled} {pattern} {minlength} {maxlength} bind:value type="text" class="validity form-control" id="input{localId}" {placeholder} {autocomplete} {name}>{/if}
 
      {#if type=="date"}     <input {required} {readonly} {disabled} {pattern} type="date" bind:value={valueD} class="validity form-control" id="input{localId}" {placeholder}>{/if}
      {#if type=="datetime"} <input {required} {readonly} {disabled} {pattern} type="datetime-local" bind:value={valueDT} class="validity form-control" id="input{localId}" {placeholder}>{/if}
      {#if type=="time"}     <input {required} {readonly} {disabled} {pattern} type="time" bind:value={value} class="validity form-control" id="input{localId}" {placeholder}>{/if}
      {#if type=="fqdn"}     <input {required} {readonly} {disabled} {pattern} bind:value type="text" class="validity form-control" id="input{localId}" {placeholder}>{/if}
      {#if type=="url"}      <input {required} {readonly} {disabled} {pattern} bind:value type="url" class="validity form-control" id="input{localId}" {placeholder}>{/if}
      {#if type=="email"}    <input {required} {readonly} {disabled} {pattern} bind:value type="text" class="validity form-control" id="input{localId}" {placeholder} {autocomplete} {name}>{/if}
      {#if type=="tel"}      <input {required} {readonly} {disabled} {pattern} bind:value type="tel" class="validity form-control" id="input{localId}" {placeholder}>{/if}
      {#if type=="number"}   <input {min} {max} {required} {readonly} {disabled} {pattern} bind:value type="number" class="validity form-control" id="input{localId}" {placeholder}>{/if}
      {#if type=="password"}
        <input class:hide={showPwd} {required} {readonly} {disabled} {pattern} bind:value type="password" class="validity form-control" id="input{localId}" {placeholder} {autocomplete} {name}>
        {#if showPassword}
          <input class:hide={!showPwd} {required} {readonly} {disabled} {pattern} bind:value type="text" class="validity form-control" id="input{localId}_show" {placeholder}>
          <button on:pointerdown={()=>showPwd=true} on:pointerup ={()=>{showPwd=false}} class="btn btn-outline-warning" type="button"><I icon={showPwd?'eye-slash':'eye'}/></button>
        {/if}
        {#if proposePassword}
          <button on:click={async ()=>value=await proposePassword()} class="btn btn-warning" type="button"><I bolt/></button>
        {/if}
        {#if showStrength}
          <div class="progressBar">
            <div style="background-color: {colors[strength-1]}; width:{$progress * 100}%;"></div>
          </div>
          <div class="small">
            <I18n id='lowercase'/> {#if lower}{@html ok}{:else}{@html ko}{/if}
            <I18n id='num'/> {#if num}{@html ok}{:else}{@html ko}{/if}
            <I18n id='specialchar'/> {#if special}{@html ok}{:else}{@html ko}{/if}
            <I18n id='uppercase'/> {#if upper}{@html ok}{:else}{@html ko}{/if}
            <I18n id='length'/> {#if len}{@html ok}{:else}{@html ko}{/if}
          </div>
        {/if}
      {/if}
      
      {#if btnDelete}<button on:click={btnDelete} class="btn btn-outline-danger" type="button"><I trash/></button>{/if}
      {#if btnAdd}<button on:click={btnAdd} class="btn btn-outline-success" type="button"><I add/></button>{/if}

      {#if btn}
        <button type="button" class="btn btn-{btn.color}" on:click={btn.action}>
          <i class="{$conf.faType} fa-{btn.icon}"/>
        </button>
      {/if}
 
    </div>
  {/if}

  {#if type=="range" && smooth} {#if showValue}<span class="ms-4">{value} {unit}</span>{/if}<input on:change={change} bind:value={valueRange} onkeydown="return false;" on:input={moveRange} {required} {readonly} {disabled} {pattern} {min} {max} {step} type="range" class="form-range" id="input{localId}" {placeholder}>{/if}
  {#if type=="range" && !smooth} {#if showValue}<span class="ms-4">{value} {unit}</span>{/if}<input on:change={change} bind:value {required} {readonly} {disabled} {pattern} {min} {max} {step} type="range" class="form-range" id="input{localId}" {placeholder}>{/if}
  
  {#if type=="hidden"} <input bind:value type="hidden" id="input{localId}">{/if}

  {#if type=="color"}
    {#if colorText}
      <div class=" row">
        <div class="col-auto">
          {#if smooth}
            <input {required} {readonly} {disabled} {value} on:change={changeColor} on:input={moveColor} type="color" class="form-control form-control-color" id="input{localId}">
          {:else}
            <input {required} {readonly} {disabled} on:change={change} bind:value type="color" class="form-control form-control-color" id="input{localId}">
          {/if}
        </div>
        <div class="col">
          <input required {readonly} {disabled} {pattern} on:keydown ={change} bind:value type="text" class="validity form-control" placeholder="#000000">
        </div>
      </div>
    {:else}
      {#if smooth}
        <input {required} {value} {readonly} {disabled} on:change={changeColor} on:input={moveColor} type="color" class="form-control form-control-color" id="input{localId}">
      {:else}
        <input {required} {readonly} {disabled} on:change={change} bind:value type="color" class="form-control form-control-color" id="input{localId}">
      {/if}
    {/if}
  {/if}

  {#if (!option && (type=="checkbox" || type=="switch")) || type=="radio" || type=="radioBtn"}
    <div class:container={inCol} class:row={inCol}>
      {#each optionsAsArray(options) as option}
        <div class="pointer form-check {inCol}" class:form-check-label-only={labelOnly} class:form-check-inline={inline} class:form-switch={type=="switch"} class:form-checkbox={type=="checkbox"} class:form-check-lg={lg}>
          {#if type=="radio" }
            <input type="radio" on:change={change} {readonly} {disabled} bind:group={value} value={option.id} class="form-check-input" id="input{localId}{option.id}">
          {:else if type=="radioBtn"}
            <input type="radio" on:change={change} {readonly} {disabled} bind:group={value} value={option.id} class="btn-check" id="input{localId}{option.id}">
          {:else if Array.isArray(set)}
            <input type="checkbox" on:change={change} {readonly} {disabled} bind:group={value} value={option.id} class="form-check-input" id="input{localId}{option.id}">
          {:else if isObject(set)}
            <input type="checkbox" on:change={change} {readonly} {disabled} bind:checked={value[option.id]} class="form-check-input" id="input{localId}{option.id}">
          {/if}
          {#if type=="radioBtn" }
            <label class="btn btn-secondary ucfirst" for="input{localId}{option.id}">
              {@html i18n(option.name || option.label || option.value, $lang)}
              {#if option.help}<div class="xsmall text-muted"><I question-circle/> {@html i18n(option.help, $lang)}</div>{/if}
            </label>
          {:else}
            <label class="pointer form-check-label ucfirst" for="input{localId}{option.id}">
              {@html i18n(option.name || option.label || option.value, $lang)}
              {#if option.help}<div class="xsmall text-muted"><I question-circle/> {@html i18n(option.help, $lang)}</div>{/if}
            </label>
          {/if}
        </div>
      {/each}
    </div>
  {/if}

  {#if option && (type=="checkbox" || type=="switch")}
  <div class="pointer form-check" class:form-switch={type=="switch"} class:form-checkbox={type=="checkbox"} class:form-check-lg={lg} class:labelLeftContainer={labelLeft}>
      {#if labelLeft}<div on:click={()=>value=!value} class="ucfirst labelLeft">{@html i18n(labelLeft, $lang)}</div>{/if}
      <input type="checkbox" on:change={change} {required} {readonly} {disabled} bind:checked={value} class:validity={type=="checkbox"} class="form-check-input" id="input{localId}">
      <label class="form-check-label ucfirst" for="input{localId}">
        {@html i18n(option, $lang)}
      </label>
    </div>
  {/if}

  {#if type=="tag"}
    <div class="input-group tags">
      {#each optionsAsArray(options) as option}
        <span on:click={()=>{if(!disabled && !readonly) toggleOpt(option.id)}} 
          class="tag rounded pointer py-1 px-2 ms-0 me-2 mb-2" 
          class:selected={value && value.includes(option.id)}
        >
        <span class="ucfirst"><I18n id={option.name || option.label || option.value || option.id}/></span>
        </span>
      {/each}
      {#if canAdd}
        <input {readonly} {disabled} class="mb-2" type="text" bind:value={addTag} placeholder="{i18n(placeholder || 'Add tag', $lang)}" on:change={addOpt}>
      {/if}
    </div>
  {/if}

  {#if type=="select"}
    <select class="validity form-select" name="input{id}" on:change={change} {readonly} {disabled} bind:value id="input{localId}" aria-label="select" {required} {autocomplete}>
      {#each optionsAsArray(options) as option}
        <option value={option.id}>{@html i18n(option.name || option.label || option.value || option.id, $lang)}</option>
      {/each}
    </select>
  {/if}

  {#if type=="hr"}
    <div class="border-bottom mt-4 fs-5 text-primary fw-bold">
      {#if icon}<i class="{icon} me-1"></i>{/if}
      <span id="hr{id || i18n(label, $lang) || localId}" class="ucfirst"><I18n id={label}/></span>
    </div>
  {/if}

  {#if type=="file"}
    {#if (label || icon)}
      <label for="input{localId}" class="form-label" on:click={handleClickToBrowse}>
        {#if icon}<i class="{icon} me-1"></i>{/if}
        <span class="ucfirst">
          <I18n id={label}/><i class="ms-1 {$conf.faType} fa-asterisk text-danger" class:d-none={!required}></i>
        </span>
      </label>
    {/if}
         
    <div class:dragging class="filebox" class:invalid
      on:click={handleClickToBrowse}
      on:drop|preventDefault={drop_handler}
      on:dragover|preventDefault={()=>{dragging=true}}
      on:dragleave|preventDefault={()=>{dragging=false}}>
          
      <input bind:this={me} {required} type="file" class="form-control" {multiple} {accept} on:input={input_handler} on:change={change}/>
    
      <div class="d-flex flex-wrap">
        {#each asArray(value) as file, i (i)}
          <div class="border rounded m-1" style="position:relative;">
            <div class="div-header bg-light" style="z-index:2; padding:4px; position:absolute;">
              <div on:click|stopPropagation={()=>removeFile(i)} class="text-danger"><I trash/></div>
            </div>
            {#if descr(file).type=="image" }
              <img class="img-fluid div-img-top" src="{descr(file).src}" alt="" style="max-height: {height};">
            {:else if descr(file).type=="video" }
              <video class="img-fluid div-img-top" controls src="{descr(file).src}" style="max-height: {height};"><track kind="captions"/></video>
            {:else} 
              <div class="div-footer">
                <i class="fa-4x {icons(descr(file).type)}"/><br>{descr(file).name || ""}
              </div>
            {/if}
          </div>
        {:else}
          <div class="">
              <I file-upload/>
              <I18n id={multiple?'input--Drag files':'input--Drag file'}/><br>
          </div>
        {/each}
      </div>
    </div>
    {#if legend}
      <small>
        {#if maxValues>1}
          {maxValues} <I18n id='input--Max files'/> -
        {/if}
        <I18n id='input--Max size'/> {maxSize} MB 
      </small>  
    {/if}
  {/if}

  {#if help}<div class="xsmall text-muted"><I question-circle/> {@html i18n(help, $lang)}</div>{/if}
  <slot name="after"/>
</div>

<style>
  .validity{
    transition: border-left .5s;
  }
  .validity:invalid{
    border-left: 4px solid red;
  }
  .validity:invalid:placeholder-shown {
    border-left: 4px solid #ff7f50ba; /* coral*/
  }

  .validity:valid{
    border-left: 4px solid green;
  }
  .validity:not([required]):not([readonly]):placeholder-shown {
    border-left: 4px solid lightblue;
  }

  .multiLangSelector {
    border-bottom: black 2px solid;
  }

  *::placeholder {
    font-style: italic;
  }

  .form-label {
    margin-bottom: 0.25rem;
  }

  .form-check {
    padding-top: 0.45rem;
  }

  .form-check-lg.form-checkbox .form-check-input {
    height: 1.4rem;
    width: 1.2rem;
    margin-top: 0.1em;
  }

  .form-check-lg.form-switch .form-check-input {
    margin-left: -2.5em;
    height: 1.4rem;
    width: 2.5rem;
    margin-top: 0.1em;
  }

  .form-check-lg label{
    padding-left: 0.5rem;
  }


  .form-check-label-only{
    padding-left: 0;
  }
  .form-check-label-only input{
    display:none;
  }
  .form-check-label-only label{
    aapadding-right:1rem;
    aapadding-bottom:1rem;
    cursor:pointer;
  }
  .form-check-label-only label:hover{
    aaatransform: scale(1.4);
    color:#0D6EFD;
    opacity: 0.8;
  }

  .form-check-label-only input:checked + label{
    aaborder: 1px solid #0D6EFD;
    color:#0D6EFD;
    font-weight: bold;
    aaatransform: scale(1.4);
  }
 
  :global(.form-check-label-only input:checked + label .cellTypeSVG svg) {
    fill:#0D6EFD!important;
  }
  :global(.form-check-label-only input + label .cellTypeSVG svg:hover) {
    fill:#000000!important;
  }
 
  .form-control:disabled, .form-control[readonly] {/** deleted in boostrap 5.2 !! **/
    background-color: #e9ecef;
    opacity: 0.8;
  }

  input[type=file] {
    position: absolute !important;
    height: 1px;
    width: 1px;
    overflow: hidden;
    clip: rect(1px 1px 1px 1px);
    clip: rect(1px, 1px, 1px, 1px);
    white-space: nowrap;
  }
  .filebox {
    min-height:6rem;
    border: #ced4da 1px solid;
    border-radius: 5px;
  }
  .filebox:hover {
    cursor: pointer;
  }
  .dragging{
    background: lightgreen;
  }


  .tag{
      border: 1px solid #0D6EFD; /*blue electric*/
      opacity: .5;
      aaborder: 1px solid var(--navBarBg-backgroundColor);
  }

  .tag.selected{
      background-color: #0D6EFD; /*blue electric*/
      color: white;
      opacity: unset;
      aabackground-color: var(--navBarBg-backgroundColor);
      aacolor: var(--navBarText-color);
  }

  .tags input {
    border: none;
    outline: none;
    border-bottom: 1px solid lightgray;
  }

  input[type="range"]::-webkit-slider-thumb {
    width: 1.5rem;
    height: 1rem;
    background-color: #0D6EFD; /*blue electric*/
    /*background-color: var(--navBarBg-backgroundColor);*/
    border: 0;
    border-radius: 1rem;
  }

  .form-range {
    padding-top: 0.9rem;
  }

  .progressBar{
    background-color:lightgray;
    width:100%;
    height:5px;
    vertical-align: top;
  }
  .progressBar>div{
    height:100%;
  }


  /****for labelLeft***/
  .labelLeftContainer {
    cursor:default;
      padding-left: unset!important;
  }
  .labelLeftContainer .form-check-input {
    margin-left:  unset!important;
    float:  unset!important;
  }


</style>